export default __webpack_public_path__ + "static/photo-claire-d5fa78e8cb8ef2f00ee06e4203de2067.webp";